<template>
  <div class="post-assignment">
    <div class="top-row">
      <p class="tips">
        <i class="el-icon-info"></i>
        <span
          >系统推荐人选适配率从大到小排列,分配岗位请先勾选相应学生后点击确定分配</span
        >
      </p>
      <el-button
        type="primary"
        size="medium"
        @click="handleAssignment"
        style="float: right"
        >确定分配</el-button
      >
    </div>

    <el-table :data="list" stripe class="list" ref="table">
      <el-table-column prop="name" label="岗位" width="120" align="center">
      </el-table-column>
      <el-table-column prop="recommendUserList" label="系统推荐人选(分数)">
        <template slot-scope="scope">
          <el-checkbox-group v-model="postUser[scope.row.postId]" :max="1">
            <el-checkbox
              v-for="item in scope.row.recommendUserList"
              :key="item.userId"
              :label="item.userId"
              :disabled="
                ids.indexOf(item.userId) != -1 &&
                postUser[scope.row.postId][0] != item.userId
              "
              >{{ item.nickName
              }}<span style="margin-left: 5px; color: #f56c6c"
                >({{ item.score || 0 }})</span
              ></el-checkbox
            >
          </el-checkbox-group>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { postRecommend, assignment } from "@/api/projectPractice/questionnaire";
export default {
  data() {
    return {
      list: [],
      postUser: {},
    };
  },
  computed: {
    ids() {
      const ids = [];
      for (let key in this.postUser) {
        ids.push(this.postUser[key][0]);
      }
      return ids;
    },
  },
  methods: {
    getList() {
      this.$loading.show();
      postRecommend({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
          this.initPostUser();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initPostUser() {
      this.list.forEach((item) => {
        this.postUser = Object.assign({}, this.postUser, {
          [item.postId]: [],
        });
        // this.$set(this.postUser, this.postUser[item.postId], []);
      });
    },
    handleAssignment() {
      let postUser = {};
      for (let key in this.postUser) {
        postUser[key] = this.postUser[key][0] || null;
      }

      this.$confirm("确定分配岗位吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          assignment({ classId: this.$route.query.id, postUser }).then(
            (res) => {
              this.$loading.hide();
              if (res.code == 0) {
                this.$message.success("分配成功");
                this.initPostUser();
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.post-assignment {
  .top-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .tips {
      float: left;
      i {
        margin-right: 5px;
        color: #909399;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>